import CampaignModel from "../../Activity/Models/RequestBody/Context/CampaignModel";
import ContentModel from "../../Activity/Models/RequestBody/Context/ContentModel";
import MiniGamesContextTag from "./MiniGamesContextTag";

export default class MiniGamesContext {
  public content: ContentModel = null;
  public tags: MiniGamesContextTag[] = [];
  public campaign: CampaignModel = null;
}
